import { getAccessoriesUsagePdfById } from "api/accessoriesUsageApi"
import { useState } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Row,
  Col,
  Button,
} from "reactstrap"
import { formatReadableDate } from "utils/formatDate"

const AccessoriesUsageViewModal = ({ isOpen, toggle, data }) => {
  const [loading, setLoading] = useState(false)

  if (!data) return null

  const vehicle = data.vehicle
  const usageBy = data.usage_by

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle} className="border-0 text-center">
        <h4 className="mb-0 fw-bold">ACCESSORIES USAGE DETAILS</h4>
      </ModalHeader>

      <ModalBody className="px-4">
        {/* ===== Meta Info ===== */}
        <Row className="mb-4">
          <Col md={6}>
            <div className="mb-2">
              <strong>Used By:</strong>
              <div>{usageBy?.name || "-"}</div>
            </div>
            {vehicle && (
              <>
                <div className="mb-2">
                  <strong>Vehicle:</strong>
                  <div>
                    {vehicle.stock_id} ({vehicle.full_chassis})
                  </div>
                </div>
                <div className="mb-2">
                  <strong>Brand & Model:</strong>
                  <div>
                    {vehicle.brand?.name} {vehicle.model?.name}{" "}
                    {vehicle.year?.name}
                  </div>
                </div>
                <div>
                  <strong>Package & Color:</strong>
                  <div>
                    {vehicle.package?.name} / {vehicle.exterior_color?.name}
                  </div>
                </div>
              </>
            )}
          </Col>

          <Col md={6} className="text-md-end">
            <div className="mb-2">
              <strong>Usage Date:</strong>
              <div>{formatReadableDate(data.usage_date)}</div>
            </div>
            <div>
              <strong>Total Accessories:</strong>
              <div>{data.items?.length || 0}</div>
            </div>
          </Col>
        </Row>

        {/* ===== Items Table ===== */}
        <Table bordered responsive className="align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: 50 }}>#</th>
              <th>Accessory Name</th>
              <th style={{ width: 100 }} className="text-end">
                Quantity
              </th>
              <th style={{ width: 100 }} className="text-end">
                Unit
              </th>
            </tr>
          </thead>
          <tbody>
            {data.items?.map((item, index) => (
              <tr key={item.id || index}>
                <td>{index + 1}</td>
                <td>{item.accessory?.name || "-"}</td>
                <td className="text-end">{item.quantity}</td>
                <td className="text-end">
                  {item.accessory?.unit?.name || "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="text-end">
          <Button
          color="primary"
          onClick={() => getAccessoriesUsagePdfById(data?.id, setLoading)}
          disabled={loading}
        >
          {loading ? "Generating PDF..." : "Download PDF"}
        </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AccessoriesUsageViewModal
